import { useEffect, useState } from "react";
import Flex from "common/Boxes/Flex";
import Text from "common/Typography/Text";
import Title from "common/Typography/Title";
import styled from "styled-components";
import { getDisplayedTime, getTimeLeft } from "@shared/utils/date";
import { LARGE_MOBILE } from "common/constants";

interface CountdownProps {
  targetDate: number;
  onCountdownOver?: () => void;
}

const Countdown = ({ targetDate, onCountdownOver }: CountdownProps) => {
  const [countdown, setCountdown] = useState(targetDate - new Date().getTime());

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown(targetDate - new Date().getTime());
    }, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  const { days, hours, minutes, seconds } = getTimeLeft(countdown);

  useEffect(() => {
    if (days + hours + minutes + seconds <= 0) {
      onCountdownOver?.();
    }
  }, [days, hours, minutes, seconds]);

  return (
    <Flex $alignItems={"flex-start"}>
      <ItemWrapper>
        <StyledTitle>{getDisplayedTime(days)}</StyledTitle>
        <StyledText>Days</StyledText>
      </ItemWrapper>
      <Divider>:</Divider>
      <ItemWrapper>
        <StyledTitle>{getDisplayedTime(hours)}</StyledTitle>
        <StyledText>Hours</StyledText>
      </ItemWrapper>
      <Divider>:</Divider>
      <ItemWrapper>
        <StyledTitle>{getDisplayedTime(minutes)}</StyledTitle>
        <StyledText>Min</StyledText>
      </ItemWrapper>
      <Divider>:</Divider>
      <ItemWrapper>
        <StyledTitle>{getDisplayedTime(seconds)}</StyledTitle>
        <StyledText>Sec</StyledText>
      </ItemWrapper>
    </Flex>
  );
};

export default Countdown;

const ItemWrapper = styled(Flex)`
  flex-direction: column;
  justify-content: flex-start;
  padding: 0 16px;
  @media (max-width: ${LARGE_MOBILE}) {
    padding: 0 12px;
  }
`;
const StyledTitle = styled(Title)`
  color: ${(p) => p.theme.colors.white};
  font-weight: ${(p) => p.theme.typography.fontWeights.EXTRA_BOLD};
  font-size: ${(p) => p.theme.typography.fontSizes.XL};
  @media (max-width: ${LARGE_MOBILE}) {
    font-size: ${(p) => p.theme.typography.fontSizes.L};
  }
`;
const StyledText = styled(Text)`
  color: ${(p) => p.theme.colors.white};
  font-size: ${(p) => p.theme.typography.fontSizes.S};
`;
const Divider = styled(Text)`
  color: ${(p) => p.theme.colors.white};
  font-size: ${(p) => p.theme.typography.fontSizes.L};
  font-weight: ${(p) => p.theme.typography.fontWeights.SEMI_BOLD};
`;
